exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dup-selected-count[data-v-360fa06c] {\n  font-weight: 600;\n  font-size: 13px;\n  white-space: nowrap;\n}\n.dup-action-link[data-v-360fa06c] {\n  font-size: 13px;\n  white-space: nowrap;\n}", ""]);

// exports
